// WARNING! This file contains some subset of JS that is not supported by type inference.
// You can try checking 'Transpile to ES5' checkbox if you want the types to be inferred

class Carousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.blocks = this.querySelectorAll(".carousel--block");
    this.container = this.querySelector(".carousel--x-container");
    this.dot_nav = this.querySelector(".carousel--dot-nav");
    this.dots = this.querySelectorAll(".carousel--dot");
    this.height_container = this.querySelector(".carousel--y-container");
    this.links = this.container && this.container.querySelectorAll("a");
    this.next = this.querySelector(".carousel--next");
    this.prev = this.querySelector(".carousel--prev");
    this.auto_rotate = "true" === this.getAttribute("data-auto-rotate");
    this.blocks_per_slide_desktop = parseInt(this.getAttribute("data-blocks-per-slide"));
    this.blocks_per_slide_mobile = parseInt(this.getAttribute("data-blocks-per-slide--mobile"));
    this.dot_nav_enabled = "true" === this.getAttribute("data-dot-nav");
    this.rotate_frequency = parseInt(this.getAttribute("data-rotate-frequency"));
    this.section_id = this.closest("[data-section-id]").getAttribute("data-section-id");
    this.total_blocks = this.blocks.length;
    this.transition_type = this.getAttribute("data-transition-type");
    this.active_slide = 1;
    this.autoplay_focus_enabled = false;
    this.dot_offset = 0;
    this.dot_width = 12;
    this.slide_pause = false;
    this.container_destination = "0px";
    this.trailing_dot_index = 0;
    this.leading_dot_index = 0;
    this.dot_nav_offset = 0;
    this.active_blocks = null;
    this.auto_slide_timer = null;
    this.blocks_per_slide = null;
    this.old_active_blocks = null;
    this.screen_size_loaded = null;
    this.slide_count = null;
    this.swipe_state = null;
    this.window_width = null;
    this.dot_change_type = null;
    this.load();
  }
  load() {
    this.initNewScreenSize();
    this.updateActive();
    theme.utils.imagesLoaded(this.active_blocks, () => {
      this.setSliderHeight();
      this.trigger("loaded");
      this.style.opacity = 1;
    }, true);
    this.getAllFocusableEl();
    this.resizeListener();
    this.mouseDownListener();
    this.swipeListener();
    this.arrowNavListeners();
    if ("slide" === this.transition_type) {
      this.loadBlocks();
    }
    if (Shopify.designMode) {
      this.blockListener();
      this.sectionListener();
    }
    if (this.auto_rotate) {
      this.autoSlide();
      this.stopAutoSlideWhenInteracting();
    }
  }
  initNewScreenSize() {
    if ("small" === theme.mqs.current_window) {
      if ("small" === this.screen_size_loaded) {
        return;
      }
      this.dot_nav.setAttribute("data-loaded", false);
      this.screen_size_loaded = "small";
      this.blocks_per_slide = this.blocks_per_slide_mobile;
      this.active_slide = Math.ceil((this.blocks_per_slide_desktop * (this.active_slide - 1) + 1) / this.blocks_per_slide_mobile);
    } else {
      if ("medium-large" === this.screen_size_loaded) {
        return;
      }
      this.screen_size_loaded = "medium-large";
      this.blocks_per_slide = this.blocks_per_slide_desktop;
      this.active_slide = Math.ceil((this.blocks_per_slide_mobile * (this.active_slide - 1) + 1) / this.blocks_per_slide_desktop);
    }
    this.slide_count = Math.ceil(this.total_blocks / this.blocks_per_slide);
    this.createDotNav();
    this.goToActiveSlide();
    this.updateActiveDot();
  }
  getAllFocusableEl() {
    this.focusable_el = theme.a11y.getFocusableEl(this);
  }
  loadBlocks() {
    this.blocks.forEach((background) => {
      background.setAttribute("data-loaded", true);
      background.setAttribute("data-loaded--mobile", true);
    });
  }
  blockListener() {
    this.blocks.on("theme:block:select", (t) => {
      var i = Math.ceil((t.target.index() + 1) / this.blocks_per_slide);
      this.updateThenGoToActiveSlide(i, true);
    });
  }
  sectionListener() {
    this.closest("[data-section-id]").on("theme:section:load", () => {
      return this.style.opacity = 1;
    });
  }
  checkForActiveModel(to) {
    var speedDial = to.querySelector("model-viewer");
    return !!speedDial && !speedDial.classList.contains("shopify-model-viewer-ui__disabled");
  }
  mouseDownListener() {
    this.container.on("mousedown touchstart", (event) => {
      var x;
      var e = event.target.closest(".carousel--block");
      if (this.checkForActiveModel(e)) {
        return false;
      }
      this.swipe_state = "swipe-started";
      this.reenableClickAfterSwiping();
      this.mouseUpListener();
      this.slide_pause = true;
      if ("slide" === this.transition_type) {
        this.drag_start = ("touchstart" === event.type ? event.targetTouches[0] : event).pageX;
        x = this.container.style.transform.replace(/[^0-9\-.,]/g, "") / 100;
        this.current_transform_pixels = this.container.offsetWidth * parseFloat(x);
        this.container.setState("");
        this.container.style.transform = `translateX(${this.current_transform_pixels}px)`;
        this.dragBegin();
      }
    }, {
      passive : true
    });
  }
  mouseUpListener() {
    window.on(`mouseup.${this.section_id} touchend.` + this.section_id, () => {
      this.swipe_state = "swipe-ended";
      this.removeMouseUpListener();
      this.dragEnd();
      if (true === this.slide_pause) {
        this.container.setState("forwards");
        this.container.style.transform = `translateX(${this.container_destination})`;
      }
    }, {
      passive : true
    });
  }
  removeMouseUpListener() {
    window.off(`mouseup.${this.section_id} touchend.` + this.section_id);
  }
  dragBegin() {
    this.setAttribute("data-dragging", true);
    window.on(`mousemove.${this.section_id} touchmove.` + this.section_id, (event) => {
      var frameLastMousePosition = ("touchmove" === event.type ? event.targetTouches[0] : event).pageX;
      let argMath14 = this.current_transform_pixels - this.drag_start + frameLastMousePosition;
      var caller = this.window_width * (this.slide_count - 1);
      if (0 < argMath14) {
        this.container.style.transform = `translateX(${argMath14 / 4}px)`;
      } else {
        if (argMath14 < -1 * caller) {
          argMath14 = caller + ((argMath14 = argMath14 * -1) - caller) / 4;
          this.container.style.transform = `translateX(-${argMath14}px)`;
        } else {
          this.container.style.transform = `translateX(${argMath14}px)`;
        }
      }
    }, {
      passive : true
    });
  }
  dragEnd() {
    this.setAttribute("data-dragging", false);
    window.off(`mousemove.${this.section_id} touchmove.` + this.section_id);
  }
  updateContainerDestination() {
    this.container_destination = (this.active_slide - 1) / this.slide_count * -100 + "%";
  }
  slideToNext(t = false) {
    this.dot_change_type = "iterate";
    let direction;
    return this.active_slide !== this.slide_count ? (this.updateActive("next"), direction = "forwards") : t && this.active_slide === this.slide_count ? (this.active_slide = 1, this.updateActive(), direction = "forwards") : this.active_slide === this.slide_count && (direction = "backwards"), "slide" === this.transition_type ? (this.updateContainerDestination(), this.container.style.transform = `translateX(${this.container_destination})`) : "fade" === this.transition_type && this.fadeSlides(), this.container.setState(direction), 
    true;
  }
  slideToPrev() {
    this.dot_change_type = "iterate";
    let direction;
    return 1 !== this.active_slide ? (this.updateActive("prev"), direction = "forwards") : 1 === this.active_slide && (direction = "backwards"), "slide" === this.transition_type ? (this.updateContainerDestination(), this.container.style.transform = `translateX(${this.container_destination})`) : "fade" === this.transition_type && this.fadeSlides(), this.container.setState(direction), true;
  }
  goToActiveSlide(t = false) {
    this.dot_change_type = "init";
    if ("slide" === this.transition_type) {
      this.updateContainerDestination();
      this.container.style.transform = `translateX(${this.container_destination})`;
    } else {
      if ("fade" === this.transition_type) {
        this.fadeSlides();
      }
    }
    if (t) {
      this.container.setState("forwards");
    }
  }
  checkStartEnd() {
    this.setAttribute("data-at-start", 1 === this.active_slide);
    if (this.prev) {
      this.prev.setAttribute("tabindex", 1 === this.active_slide ? "-1" : "0");
    }
    this.setAttribute("data-at-end", this.active_slide === this.slide_count);
    if (this.next) {
      this.next.setAttribute("tabindex", this.active_slide === this.slide_count ? "-1" : "0");
    }
  }
  updateActive(staticIdx = false) {
    if ("next" === staticIdx) {
      this.active_slide += 1;
      if (!(!this.autoplay_focus_enabled && false !== this.auto_rotate)) {
        this.prev.focus();
      }
    } else {
      if ("prev" === staticIdx) {
        --this.active_slide;
        if (!(!this.autoplay_focus_enabled && false !== this.auto_rotate)) {
          this.next.focus();
        }
      }
    }
    var tagStart = (this.active_slide - 1) * this.blocks_per_slide;
    var end = tagStart + this.blocks_per_slide;
    if (null !== this.active_blocks) {
      this.old_active_blocks = this.active_blocks;
    }
    this.active_blocks = [...this.blocks].slice(tagStart, end);
    this.toggleFocusableEl();
    this.checkStartEnd();
  }
  toggleFocusableEl() {
    if (this.disabled_el) {
      this.disabled_el.forEach((display) => {
        return display.setAttribute("tabindex", "0");
      });
    }
    this.disabled_el = [];
    this.blocks.not(this.active_blocks).forEach((extensionGroup) => {
      theme.a11y.getFocusableEl(extensionGroup).forEach((bone_in) => {
        return this.disabled_el.push(bone_in);
      });
    });
    if (this.disabled_el.length) {
      this.disabled_el.forEach((elem) => {
        return elem.setAttribute("tabindex", "-1");
      });
    }
  }
  setSliderHeight() {
    var lats = this.active_blocks.map((toastStage) => {
      return toastStage.offsetHeight;
    });
    this.height_container.style.height = Math.max(...lats) + "px";
  }
  swipeListener() {
    window.on("theme:swipe:left", () => {
      if ("swipe-started" === this.swipe_state) {
        this.slide_pause = false;
        this.slideToNext();
        this.setSliderHeight();
        this.updateActiveDot();
        this.preventClickWhenSwiping();
      }
    });
    window.on("theme:swipe:right", () => {
      if ("swipe-started" === this.swipe_state) {
        this.slide_pause = false;
        this.slideToPrev();
        this.setSliderHeight();
        this.updateActiveDot();
        this.preventClickWhenSwiping();
      }
    });
  }
  createDotNav() {
    if (this.dot_nav_enabled && this.dot_nav && 1 !== this.slide_count) {
      if (this.dot_nav) {
        this.dot_nav.innerHTML = "";
      }
      var fragment = new DocumentFragment;
      for (let t = 0; t < this.slide_count; t++) {
        fragment.append(theme.utils.parseHtml('<div class="carousel--dot"></div>'));
      }
      this.dot_nav.appendChild(fragment);
      this.dots = this.dot_nav.querySelectorAll(".carousel--dot");
      if (this.dots && (this.dotNavListeners(), 5 < this.dots.length && this.dotTransitionListener(), "small" === theme.mqs.current_window)) {
        this.dots.forEach((display) => {
          return display.setAttribute("tabindex", "0");
        });
      }
    }
  }
  dotNavListeners() {
    this.dots.off(`click.${this.section_id} keydown.` + this.section_id);
    this.dots.on(`click.${this.section_id} keydown.` + this.section_id, ({
      key : key,
      target : object,
      type : name
    }) => {
      if (!("keydown" === name && "Enter" !== key)) {
        this.updateThenGoToActiveSlide(object.index() + 1, true);
      }
    });
  }
  dotTransitionListener() {
    this.dots.off("transitionend");
    this.dots.on("transitionend", ({
      target : $submenuTarget
    }) => {
      if ($submenuTarget === this.dots[this.active_slide - 1]) {
        this.dot_nav.style.transform = `translateX(${this.dot_offset}px)`;
      }
    });
  }
  updateActiveDot() {
    if (this.dots) {
      this.dots.forEach((radio) => {
        return radio.setAttribute("data-active", radio === this.dots[this.active_slide - 1]);
      });
    }
    if (this.dots[this.active_slide - 1] && 5 < this.dots.length) {
      this.updateTrailingLeadingDots();
    } else {
      this.dot_nav.setAttribute("data-loaded", true);
    }
  }
  updateTrailingLeadingDots() {
    var target;
    var index;
    var notEmpty = "" !== this.dots[this.active_slide - 1].getAttribute("data-position");
    if (this.active_slide === this.leading_dot_index) {
      this.leading_dot_index++;
      this.trailing_dot_index++;
      this.dots.forEach(($row) => {
        return $row.setAttribute("data-position", "");
      });
      target = [...this.dots].slice(this.active_slide - 3, this.active_slide);
      if (4 <= this.active_slide) {
        this.dots[this.active_slide - 4].setAttribute("data-position", "trailing-1");
        target.push(this.dots[this.active_slide - 4]);
      }
      if (5 <= this.active_slide) {
        this.dots[this.active_slide - 5].setAttribute("data-position", "trailing-2");
        target.push(this.dots[this.active_slide - 5]);
      }
      if (this.dots.length > this.active_slide) {
        this.dots[this.active_slide].setAttribute("data-position", "leading-1");
        target.push(this.dots[this.active_slide]);
      }
      if (this.dots.length > this.active_slide + 1) {
        this.dots[this.active_slide + 1].setAttribute("data-position", "leading-2");
        target.push(this.dots[this.active_slide + 1]);
      }
      this.dots.not(target).forEach(($p) => {
        return $p.setAttribute("data-position", "hidden");
      });
      this.moveDots(notEmpty);
      if ("init" === this.dot_change_type) {
        this.dot_nav.setAttribute("data-loaded", true);
      }
    } else {
      if (this.active_slide === this.trailing_dot_index) {
        this.leading_dot_index--;
        this.trailing_dot_index--;
        this.dots.forEach(($row) => {
          return $row.setAttribute("data-position", "");
        });
        index = [...this.dots].slice(this.active_slide - 1, this.active_slide + 2);
        if (2 <= this.active_slide) {
          this.dots[this.active_slide - 2].setAttribute("data-position", "trailing-1");
          index.push(this.dots[this.active_slide - 2]);
        }
        if (3 <= this.active_slide) {
          this.dots[this.active_slide - 3].setAttribute("data-position", "trailing-2");
          index.push(this.dots[this.active_slide - 3]);
        }
        if (this.dots.length > this.active_slide + 2) {
          this.dots[this.active_slide + 2].setAttribute("data-position", "leading-1");
          index.push(this.dots[this.active_slide + 2]);
        }
        if (this.dots.length > this.active_slide + 3) {
          this.dots[this.active_slide + 3].setAttribute("data-position", "leading-2");
          index.push(this.dots[this.active_slide + 3]);
        }
        this.dots.not(index).forEach(($p) => {
          return $p.setAttribute("data-position", "hidden");
        });
        this.moveDots(notEmpty);
        if ("init" === this.dot_change_type) {
          this.dot_nav.setAttribute("data-loaded", true);
        }
      } else {
        if ("init" === this.dot_change_type) {
          this.initDotIndices();
          this.updateTrailingLeadingDots();
        } else {
          this.moveDots(notEmpty);
        }
      }
    }
  }
  initDotIndices() {
    if (this.dots) {
      this.dots.forEach(($row) => {
        return $row.setAttribute("data-position", "");
      });
    }
    if (this.slide_count - this.active_slide <= 2) {
      this.leading_dot_index = this.active_slide;
      this.trailing_dot_index = this.active_slide - 3;
    } else {
      if (2 < this.slide_count - this.active_slide) {
        this.trailing_dot_index = this.active_slide;
        this.leading_dot_index = this.active_slide + 3;
      }
    }
  }
  moveDots(index) {
    if (this.dot_nav && this.dots) {
      if (this.active_slide <= 3) {
        this.dot_offset = 0;
      } else {
        if (this.active_slide >= this.slide_count - 2) {
          this.dot_offset = (5 - this.slide_count) * this.dot_width;
        } else {
          this.dot_offset = (3 - this.active_slide) * this.dot_width;
        }
      }
      if (!index) {
        this.dot_nav.style.transform = `translateX(${this.dot_offset}px)`;
      }
    }
  }
  arrowNavListeners() {
    this.prev.on("click keydown", (e) => {
      if (!("keydown" === e.type && "Enter" !== e.key)) {
        this.slideToPrev();
        this.setSliderHeight();
        this.updateActiveDot();
      }
    });
    this.next.on("click keydown", (e) => {
      if (!("keydown" === e.type && "Enter" !== e.key)) {
        this.slideToNext();
        this.setSliderHeight();
        this.updateActiveDot();
      }
    });
  }
  resizeListener() {
    this.window_width = document.documentElement.clientWidth;
    window.on(`resize.${this.section_id} theme:carousel:imagesResized`, theme.utils.debounce(50, () => {
      this.window_width = document.documentElement.clientWidth;
      this.initNewScreenSize();
      this.updateActive();
      this.setSliderHeight();
      this.moveDots();
      if ("small" === theme.mqs.current_window && this.dots) {
        this.dots.forEach((display) => {
          return display.setAttribute("tabindex", "0");
        });
      } else {
        if (this.dots) {
          this.dots.forEach((option) => {
            return option.removeAttribute("tabindex");
          });
        }
      }
    }));
  }
  reenableClickAfterSwiping() {
    this.links.off("click." + this.section_id);
  }
  preventClickWhenSwiping() {
    this.links.on("click." + this.section_id, (event) => {
      return event.preventDefault();
    });
  }
  autoSlide() {
    this.auto_slide_timer = setInterval(() => {
      this.slideToNext(true);
      this.updateActiveDot();
      this.setSliderHeight();
    }, 1e3 * this.rotate_frequency);
  }
  stopAutoSlideWhenInteracting() {
    this.on("click touchstart", () => {
      this.autoplay_focus_enabled = true;
      clearInterval(this.auto_slide_timer);
      this.off("click touchstart");
    }, {
      passive : true
    });
    this.focusable_el.on("focus", () => {
      this.autoplay_focus_enabled = true;
      clearInterval(this.auto_slide_timer);
      this.focusable_el.off("focus");
    }, {
      passive : true
    });
  }
  fadeSlides() {
    if (null !== this.active_blocks && null !== this.old_active_blocks) {
      this.blocks.forEach((div) => {
        div.setAttribute("data-active", "");
        div.setAttribute("data-loaded", false);
        div.setAttribute("data-loaded--mobile", false);
      });
      this.old_active_blocks.forEach((div) => {
        div.setAttribute("data-active", "old");
        div.style.left = "0%";
      });
      this.active_blocks.forEach((div, i) => {
        div.setAttribute("data-active", "new");
        div.style.left = 100 * i / this.total_blocks + "%";
      });
    }
  }
  updateThenGoToActiveSlide(index, i = false) {
    this.active_slide = index;
    this.updateActive();
    this.goToActiveSlide(i);
    this.setSliderHeight();
    this.initDotIndices();
    this.updateActiveDot();
  }
}
const carouselEl = customElements.get("carousel-root");

if (!carouselEl) {
  customElements.define("carousel-root", Carousel);
}